export class DomUtil {
    public static translatePosition($element: JQuery): { x: number; y: number } {
        const matrix = $element.css("-webkit-transform");
        // the browser reports a residual translation in scientific notation, e.g.
        // matrix(1, 0, 0, 1, -1.13221e-09, 0). a plain [\d.]+ scan tore that into "-1.13221" and
        // "-09", so the two slots read below came back as a translation of several px that was never
        // there - and every scrollTo starting from it made the content visibly jump
        // an environment without the vendor property (jsdom in unit tests) reports none at all, which reads as no translation
        const matrixMatch = matrix?.match(/-?\d*\.?\d+(?:e[+-]?\d+)?/gi);
        if (matrixMatch == null) return { x: 0, y: 0 };

        // matrix() carries the translation in slots 5 and 6, matrix3d() in slots 13 and 14
        const translateIndex = matrixMatch.length === 16 ? 12 : 4;

        return {
            x: parseFloat(matrixMatch[translateIndex]),
            y: parseFloat(matrixMatch[translateIndex + 1]),
        };
    }

    public static momentumResistance(overdrag: number, range: number): number {
        if (overdrag === 0) return 0;

        const x = (1 / range) * overdrag;
        const c = Math.pow(Math.E, -x);
        const resistance = (1 - c) / (1 + c);
        return -overdrag + resistance * range;
    }

    static scrollTo($scrollContainer: JQuery, offset: JQuery | number, finished?: { () }, useAnimation?: boolean) {
        let topPosition = 0;

        if (offset["length"] !== undefined) topPosition = (offset as JQuery).position().top;
        else topPosition = offset as number;

        //scroll a bit above it
        topPosition -= 6;

        if (topPosition < 0) topPosition = 0;

        if (useAnimation === undefined || useAnimation === true) {
            $scrollContainer.one("mousedown wheel DOMMouseScroll mousewheel keyup touchmove", () => {
                $scrollContainer.stop();
            });

            $.when($scrollContainer.animate({ scrollTop: topPosition }, 600, "easeOutExpo")).then(() => {
                if (finished !== undefined) finished();

                $scrollContainer.off("mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
            });
        } else {
            $scrollContainer.scrollTop(topPosition);
        }
    }
}
